import { ca } from '@cian/analytics';

interface IRecommendation {
  id: number;
  position: number;
}

interface ITrackShowMoreRecommendations {
  offerId: number;
  recommendations: IRecommendation[];
}

/**
 * @see https://conf.cian.tech/pages/viewpage.action?pageId=1469163170
 * Событие №4
 */
export const trackShowMoreClick = ({ offerId, recommendations }: ITrackShowMoreRecommendations) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'show_more',
    action: 'click_sopr',
    label: 'booked_similar_offers_building',
    products: [{ id: offerId }],
    page: {
      extra: {
        recommended_objects: recommendations,
      },
    },
  });
};

/**
 * @see https://conf.cian.tech/pages/viewpage.action?pageId=1469163170
 * Событие №6
 */
export const trackShowRecommendations = ({ offerId, recommendations }: ITrackShowMoreRecommendations) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Card',
    action: 'show_sopr',
    label: 'booked_similar_offers_building',
    products: [{ id: offerId }],
    page: {
      extra: {
        recommended_objects: recommendations,
      },
    },
  });
};

interface ITrackOfferClickParams {
  offerId: number;
  position: number;
  recommendationId: number;
}

/**
 * @see https://conf.cian.tech/pages/viewpage.action?pageId=1469163170
 * Событие №7
 */
export const trackOfferClick = ({ offerId, position, recommendationId }: ITrackOfferClickParams) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Card',
    action: 'click_sopr',
    label: 'booked_similar_offers_building',
    products: [{ id: recommendationId }],
    page: {
      extra: {
        source_id: offerId,
        position,
      },
    },
  });
};
